import { render, staticRenderFns } from "./BaseDenuncia.vue?vue&type=template&id=84d1ea70&scoped=true&"
import script from "./BaseDenuncia.vue?vue&type=script&lang=js&"
export * from "./BaseDenuncia.vue?vue&type=script&lang=js&"
import style0 from "./BaseDenuncia.vue?vue&type=style&index=0&id=84d1ea70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d1ea70",
  null
  
)

export default component.exports